// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

export const patientEvents = (state) =>
  get(state, ['reports', 'patientEvents'], {})

export const patientEventsReport$ = createSelector(
  patientEvents,
  ({ patientEventsReport = [] }) => patientEventsReport
)

export const patientEventsReportLoading$ = createSelector(
  patientEvents,
  ({ patientEventsReportLoading = false }) => patientEventsReportLoading
)
